"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../../createSvgIcon"));

var _More = _interopRequireDefault(require("@rsuite/icon-font/lib/legacy/More"));

// Generated by script, don't edit it please.
var More = (0, _createSvgIcon["default"])({
  as: _More["default"],
  ariaLabel: 'more',
  category: 'legacy',
  displayName: 'More'
});
var _default = More;
exports["default"] = _default;
module.exports = exports.default;